import { responseHandler } from './apiHelper';

const normalizeBook = (book) => {
  if (!book) {
    return null;
  }

  return {
    ...book,
    authors: (book.authors || []).map((author) => (
      typeof author === 'string' ? author : author.name
    )),
  };
};

export const getBook = async (isbn) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(isbn)) {
    return null;
  }

  return fetch(`/api/v1/books/${encodeURIComponent(isbn)}`)
    .then((res) => {
      if (!res.ok) {
        return responseHandler(res);
      }

      return res.text();
    })
    .then((body) => (body ? JSON.parse(body) : null))
    .then(normalizeBook);
};

export const getTopTags = async (isbn, count = 16) => (
  fetch(`/api/v1/books/${encodeURIComponent(isbn)}/tags/top?count=${encodeURIComponent(count)}`)
    .then(responseHandler)
);

export const getExternalPrices = async (isbn) => (
  fetch(`/api/v1/external-prices/?isbn=${encodeURIComponent(isbn)}`)
    .then(responseHandler)
);

export const listBookNotifications = async () => (
  fetch('/api/v1/users/me/notifications', {
    credentials: 'same-origin',
  }).then(responseHandler)
);

export const createBookNotification = async (isbn) => (
  fetch('/api/v1/users/me/notifications', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ isbn: parseInt(isbn, 10) }),
  }).then(responseHandler)
);

export const deleteBookNotification = async (bookId) => (
  fetch(`/api/v1/users/me/notifications/${encodeURIComponent(bookId)}`, {
    method: 'DELETE',
    credentials: 'same-origin',
  }).then(responseHandler)
);

/**
 * Updates the delivery channels of an existing book notification.
 *
 * @param {number|string} bookId Book id the notification is attached to
 * @param {object} updates Fields to update on the form {sendEmail?}
 * @return {Promise} Fetch response with the updated notification
 * */
export const updateBookNotification = async (bookId, updates = {}) => (
  fetch(`/api/v1/users/me/notifications/${encodeURIComponent(bookId)}`, {
    method: 'PUT',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updates),
  }).then(responseHandler)
);

export const getAveragePrice = async (isbn) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(isbn)) {
    return null;
  }

  return fetch(`/api/v1/books/${encodeURIComponent(isbn)}/average-price`)
    .then((res) => res.json());
};

/**
 * Asks the server to search for a book.
 * Uses the autocomplete endpoint.
 * */
export const searchBook = async (query) => {
  if (query.trim().length < 2) {
    return [];
  }

  const encoded = encodeURIComponent(query);

  return fetch(`/api/v1/books/autocomplete?term=${encoded}`).then((res) => res.json());
};

export const searchBooks = async (query, offset = 0, limit = 30) => {
  const encoded = encodeURIComponent(query);

  return fetch(`/api/v1/books/search?query=${encoded}&offset=${offset}&limit=${limit}`)
    .then(responseHandler);
};

/**
 * Asks the server for the most popular books on iBok,
 * shown on the frontpage.
 * */
export const getMostPopularBooks = async () => (
  fetch('/api/v1/books/popular').then(responseHandler)
);

export const submitMissingBook = async (isbn) => fetch('/api/v1/books/missing', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ isbn }),
}).then(responseHandler);
